import { AssignmentDetails } from 'century-core/core-apis/assignment/types';
import { useAuth } from 'century-core/core-auth/hooks/useAuth';
import { getFeatureFlagData } from 'century-core/core-auth/utils';
import { useDateTimer } from 'century-core/core-utils/hooks/use-date-timer';
import { copyToClipboard } from 'century-core/core-utils/utils/utils';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { useCopyAssignmentLinkMixpanel } from './mixpanel';

export const useAssignmentLabelsTranslation = () => {
  const { formatMessage } = useIntl();
  return {
    assignmentName: formatMessage({ id: 'assignment-name-label', defaultMessage: 'Name' }),
    subject: formatMessage({ id: 'assignment-subject-label', defaultMessage: 'Subject' }),
    instructions: formatMessage({ id: 'assignment-instructions-label', defaultMessage: 'Instructions' }),
    startDate: formatMessage({ id: 'assignment-start-date-label', defaultMessage: 'Start Date' }),
    startTime: formatMessage({ id: 'assignment-start-time-label', defaultMessage: 'Start Time' }),
    dueDate: formatMessage({ id: 'assignment-due-date-label', defaultMessage: 'Due Date' }),
    dueTime: formatMessage({ id: 'assignment-due-time-label', defaultMessage: 'Due Time' }),
    lateSubmission: formatMessage({ id: 'assignment-late-submission-label', defaultMessage: 'Late Submission' }),
    multipleAttempts: formatMessage({ id: 'assignment-multiple-attempts-label', defaultMessage: 'Multiple Attempts' }),
    lastUpdatedBy: formatMessage({ id: 'assignment-last-updated-by-label', defaultMessage: 'Last Updated By' }),
    lastUpdatedAt: formatMessage({ id: 'assignment-last-updated-at-label', defaultMessage: 'Last Updated At' }),
    unknownField: formatMessage({ id: 'unknown-field', defaultMessage: 'Unknown' }),
  };
};

export const useHasExtendedDueDate = () => {
  const auth = useAuth();
  const hasExtendedDueDate = getFeatureFlagData<{ extendedDueDate: boolean }>(auth, 'assignments', 'newAssignments')?.extendedDueDate;

  return hasExtendedDueDate;
};

export const useAssignmentTimer = (assignment: AssignmentDetails | undefined, onExpiry: () => void) => {
  const startAt = assignment?.schedule?.startAt;
  const isScheduled = assignment?.status === 'SCHEDULED';
  const dates = startAt && isScheduled ? [startAt] : [];

  useDateTimer(dates, onExpiry);
};

export const useCopyAssignmentLink = (assignment: AssignmentDetails) => {
  const { formatMessage } = useIntl();
  const trackCopyLink = useCopyAssignmentLinkMixpanel(assignment);

  return () => {
    const url = `${window.location.origin}/learn/assignments/due/${assignment.assignmentId}`;
    copyToClipboard(url);
    trackCopyLink();
    toast.info(formatMessage({ id: 'assignment-url-copied-toast', defaultMessage: 'Assignment link copied to clipboard.' }));
  };
};
